export const companyAdapter = (company) => {
  return {
    id: company.id,
    companyNames: company.company_aliases,
    competitors: company.competitor_aliases,
    description: company.company_description,
    createdAt: company.created_at,
    updatedAt: company.updated_at,
  };
};
